import { Helmet } from "react-helmet-async";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Home.css";
import CollageGallery from "../components/CollageGallery";
import { Link } from "react-router-dom";
// import { Link } from "react-router-dom";
import {
  motion,
  AnimatePresence,
  useScroll,
  useTransform
} from "framer-motion";

import { useEffect, useState, useRef } from "react";
import Lenis from "@studio-freight/lenis";

/* ================= VIDEO ================= */
const videos = Array.from({ length: 10 }, (_, i) => `/web/videos/${i + 1}.mp4`);

const getVideoSource = () => {
  return window.innerWidth <= 768
    ? ["https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/videos/mobilevideo.mp4"]
    : ["https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/videos/mainvideo.mp4"];
};

/* ================= PRODUCTS ================= */

const products = [
  {
    href: "products/homes",
    img: "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/img/products/homes.png",
    title: "Homes",
    desc: "Step into a home where every detail whispers luxury."
  },
  {
    href: "products/experience-center",
    img: "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/img/products/Experince.png",
    title: "Experience Centers",
    desc: "Immersive brand storytelling environments."
  },
  {
    href: "products/offices",
    img: "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/img/products/office.jpg",
    title: "Offices",
    desc: "Spaces that drive performance and creativity."
  },
  {
    href: "products/sample",
    img: "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/img/products/samap.png",
    title: "Sample Apartments",
    desc: "Experience your space before it exists."
  }
];

/* ================= TESTIMONIALS ================= */

const testimonials = [
  {
    video: "https://www.youtube.com/embed/5Lkds1a1D70",
    text: "Association with SmartVizX has helped us hugely. It provides us nearly 20-25 minutes more with a potential buyer.",
    author: "Ankur Maheshwari",
  },
  {
    video: "https://www.youtube.com/embed/EvgCICJ-gqI",
    text: "I was amazed to see how they've set out to change the game completely...",
    author: "Chakrit Vorachacreyanan",
  },
  {
    video: "https://www.youtube.com/embed/LqRkETnIPC8",
    text: "I am super excited about what SmartVizX is developing...",
    author: "Ashwin Chadha",
  },
];

/* ================= MAGNETIC BUTTON ================= */

function Magnetic({ children }) {
  const ref = useRef(null);

  const move = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    ref.current.style.transform = `translate(${x * 0.25}px, ${y * 0.25}px)`;
  };

  const reset = () => {
    ref.current.style.transform = "translate(0,0)";
  };

  return (
    <div ref={ref} onMouseMove={move} onMouseLeave={reset}>
      {children}
    </div>
  );
}

function Home() {
const [isMuted, setIsMuted] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showRecentPosts] = useState(true);
const [videoSources, setVideoSources] = useState([]);



useEffect(() => {
  const updateVideo = () => {
    setVideoSources(getVideoSource());
  };

  updateVideo(); // initial load

  window.addEventListener("resize", updateVideo);

  return () => {
    window.removeEventListener("resize", updateVideo);
  };
}, []);
  /* SMOOTH SCROLL */
  useEffect(() => {
    const lenis = new Lenis({ smooth: true, lerp: 0.08 });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
  }, []);

  /* LOADER */
  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(t);
  }, []);


  const [cityForm, setCityForm] = useState({
  name: "",
  mobile: "",
  email: "",
  city: "",
});

const handleCityChange = (e) => {
  setCityForm({
    ...cityForm,
    [e.target.name]: e.target.value,
  });
};

const handleCitySubmit = (e) => {
  e.preventDefault();

  const { name, mobile, email, city } = cityForm;

  if (!name || !mobile || !city) {
    alert("Please fill required fields");
    return;
  }

  const text = `Hi SmartvizX Team 👋

📌 New City Inquiry

👤 Name: ${name}
📱 Mobile: ${mobile}
📧 Email: ${email || "Not provided"}
📍 City: ${city}

🕒 Time: ${new Date().toLocaleString()}
🌐 Source: Home Page City Form`;

  const url = `https://wa.me/919910661689?text=${encodeURIComponent(text)}`;

  window.open(url, "_blank");
};
  /* CURSOR */
  const cursorRef = useRef(null);
  useEffect(() => {
    const move = (e) =>
      cursorRef.current.style.transform =
        `translate(${e.clientX}px, ${e.clientY}px)`;
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  /* HERO VIDEO */
  const [currentVideo, setCurrentVideo] = useState(0);
useEffect(() => {
  if (videoSources.length <= 1) return;

  const i = setInterval(() => {
    setCurrentVideo((p) => (p + 1) % videoSources.length);
  }, 9000);

  return () => clearInterval(i);
}, [videoSources]);

  /* HORIZONTAL SCROLL */
  const horizontalRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: horizontalRef,
    offset: ["start start", "end start"]
  });
const x = useTransform(scrollYProgress, [-0, 1], ["-4%", "-90%"]);
  return (
    <>
      <Helmet><title>SmartVizX</title></Helmet>

      {/* LOADER */}
      {loading && (
        <div className="studio-loader">
      <motion.div
  initial={{ scale: .8, opacity: 0 }}
  animate={{ scale: 1, opacity: 1 }}
  className="studio-loader-text"
>
  <img src="/img/finllogo.png" alt="SmartVizX Logo" />
</motion.div>
        </div>
      )}

      <div className="cursor" ref={cursorRef} />
      <Navbar />

      {/* HERO */}
      <section className="hero">
       <AnimatePresence mode="wait">
  <motion.video
    key={videoSources[currentVideo]}
    src={videoSources[currentVideo]}
    autoPlay
    muted
    loop
    playsInline
    preload="auto"
    className="hero-video"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  />
</AnimatePresence>

<button
  className="sound-toggle-btn"
  onClick={() => {
    const video = document.querySelector(".hero-video");
    if (video) {
      video.muted = !video.muted;
      setIsMuted(video.muted);
    }
  }}
>
  {isMuted ? "🔇 Sound Off" : "🔊 Sound On"}
</button>
        <div className="hero-overlay" />

        <motion.div className="hero-content">
          {/* <h1>Designing Experiences.<br />Building Emotion.</h1> */}

          <div className="hero-buttons">
            <Magnetic>
              {/* <a href="products" className="lux-btn">Explore Work</a> */}
            </Magnetic>

            <Magnetic>
              {/* <button className="lux-btn glass" onClick={()=>setShowModal(true)}>
                Connect With Us
              </button> */}
            </Magnetic>
          </div>
        </motion.div>

        <div className="film-grain" />
      </section>

     
<motion.section
  className="split-hero"
  initial="rest"
  whileHover="hover"
  animate="rest"
>
  {/* LEFT */}
  <motion.div 
    className="hero-half"
  
  >
<motion.img
  src="https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/web/1.jpg"
  alt="Project"
  className="hero-image"
  variants={{
    rest: { scale: 1 },
    hover: { 
      scale: 1.6,
      x: -30,
      y: -20,
      transition: { duration: 0.45, ease: [0.3, 1, 0.2, 1] }
    }
  }}
/>

    <div className="overlay-dark" />

    <motion.div
      className="hero-text"
      variants={{
        rest: { y: 40, opacity: 0 },
        hover: { y: 0, opacity: 1 }
      }}
      transition={{ duration: 0.8 }}
    >
      <h2 className="h2">Immersive Design</h2>
      <p>Experience architecture in motion.</p>
    </motion.div>
  </motion.div>


  {/* RIGHT */}
  <motion.div 
    className="hero-half"
   
  >
  <motion.img
  src="https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/web/2.png"
  alt="Project 2"
  className="hero-image"
  variants={{
    rest: { scale: 1 },
    hover: { 
      scale: 1.6,
      x: 30,
      y: -20,
      transition: { duration: 0.45, ease: [0.3, 1, 0.2, 1] }
    }
  }}
/>

    <div className="overlay-dark" />

    <motion.div
      className="hero-text"
      variants={{
        rest: { y: 40, opacity: 0 },
        hover: { y: 0, opacity: 1 }
      }}
      transition={{ duration: 0.8 }}
    >
      <h2>Quiet Luxury</h2>
      <p>Where emotion meets space.</p>
    </motion.div>
  </motion.div>

</motion.section>




<section className="luxury-video-section">

  <motion.div
    className="video-track"
    animate={{ x: ["0%", "-50%"] }}
    transition={{
      ease: "linear",
      duration: 30,
      repeat: Infinity
    }}
  >
    {[...videos, ...videos].map((src, index) => (
      <div className="video-card" key={index}>
        <video
          src={src}
          autoPlay
          loop
          muted
          playsInline
        />
      </div>
    ))}
  </motion.div>

</section>


      {/* HORIZONTAL PRODUCTS */}
      <section className="horizontal-section" ref={horizontalRef}>
       <h1 className="head">Our Work</h1> 
        <div className="sticky-wrapper">
              <div className="horizontal-scroll-container">

         <motion.div className="horizontal-track" style={{ x }}>
  {products.map((p,i)=>(
  <Link key={i} to={`/${p.href}`} className="product-card">
      <div className="product-image-wrap">
<img src={p.img} alt={p.title} />      </div>

      <div className="product-info">
        <h3>{p.title}</h3>
        <p>{p.desc}</p>
      </div>
    </Link>
  ))}
</motion.div>
        </div>
        </div>
      </section>

 {/* COMPANY TEXT */}
      <section className="company-text-section">
        <div className="container">
          <p>
            We design and build innovative spaces using proprietary immersive
            technology ensuring that performance meets emotion. From flagship
            offices to experience centers and bespoke residences, we create
            environments that embody a brand’s story and elevate how people feel.
          </p>

<h3 className="magic-heading">
  This is where the magic starts
</h3>
         <div className="ribbon">
  <div className="ribbon-track">
    <span>
      100+ Happy Customers • 10 Million+ Sq. Ft. Designed & Delivered • 250+ Immersive Collaborations •
    </span>

    <span>
      100+ Happy Customers • 10 Million+ Sq. Ft. Designed & Delivered • 250+ Immersive Collaborations •
    </span>
     <span>
      100+ Happy Customers • 10 Million+ Sq. Ft. Designed & Delivered • 250+ Immersive Collaborations •
    </span>
  </div>
</div>

        </div>

       <div className="client-logo-slider">
  <div className="clogo-track">
    {[
      "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/ourproducts/AURealestate.png",
      "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/ourproducts/FILATEX.png",
      "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/ourproducts/Indigo.png",
      "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/ourproducts/interOCEAN.jpg",
      "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/ourproducts/M3M.png",
      "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/ourproducts/Quikrlogo.png",
      "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/ourproducts/Smartworld.jfif",
      "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/ourproducts/SmartWorldonedxp.png",
      "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/ourproducts/quint.png",
      "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/ourproducts/TREVOCLogo.jpg",
      "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public/ourproducts/Upgrad.png"
    ].map((img, i) => (
      <div className="clogo" key={i}>
        <img src={img} alt="" />
      </div>
    ))}
  </div>
</div>
      </section>


    <CollageGallery />
     {/* RECENT POSTS */}
{showRecentPosts && (
  <section className="recent-posts-section container">

    <div className="recent-header">
      <h2 className="recent-title">Recent Posts</h2>
      <p className="recent-sub">
        Ideas, innovation and immersive design thinking from our team.
      </p>
    </div>
<div className="recent-grid">
  {[
     {
    link: "blog/A-Blueprint",
    // img: 'blog1.jpg',
    title: "Designing Immersive Experience Centers: A Blueprint for Emotional Impact",
    author: 'Gautam Tewari',
    // date: '10 July, 2025',
  },
      {
    link: 'blog/Boosting-Workplace',
    title: 'Boosting Workplace Performance: Lessons from High-Performance Office Environments',
    author: 'Gautam Tewari',
  },
     {
    link: 'blog/Trezi',
    // img: 'blog3.jpg',
    title: 'Smartvizx in Action: How Virtual Walkthroughs Revolutionize Design and Delivery',
    author: 'Gautam Tewari',
    // date: '25 June, 2025',
  },
    {
      link: "blog/Sustainable",
      title:
        "How Can Technology Save Environment And Give Our Planet A Fresh Lease of Life!",
      author: "Gautam Tewari",
    },
  ].map((p, i) => (
    <Link
      key={i}
      to={`/${p.link}`}
      className="recent-card"
    >
      <div className="recent-card-accent" />

      <div className="recent-card-content">
        <p className="recent-card-title">{p.title}</p>
        <p className="recent-card-author">By {p.author}</p>
      </div>

      <div className="recent-card-arrow">→</div>
    </Link>
  ))}
</div>

   <div className="recent-view">
  <Link to="/blog" className="recent-btn">
    Explore All Articles
  </Link>
</div>

  </section>
)}


{/* CITIES WE SERVE SECTION */}
<section className="cities-section">

  <div className="cities-container">

    <div className="cities-left">
      <h2>Cities We Served</h2>
      <p>
        Bringing bespoke design experiences across India's leading cities.
      </p>

      <img
        src="map.png"
        alt="India Map"
        className="india-map"
      />
    </div>

    <div className="cities-form-wrapper">

      <div className="cities-form">

        <h3>Talk to our design team </h3>

        <form onSubmit={handleCitySubmit}>

  <div className="form-group">
    <input
      type="text"
      name="name"
      required
      onChange={handleCityChange}
    />
    <label>Name*</label>
  </div>

  <div className="form-group">
    <input
      type="tel"
      name="mobile"
      required
      onChange={handleCityChange}
      // placeholder="+91 98xxxxxxx"
    />
    <label>Mobile*</label>
  </div>

  <div className="form-group">
    <input
      type="email"
      name="email"
      onChange={handleCityChange}
    />
    <label>Email (Optional)</label>
  </div>

  <div className="form-group">
    <select
      name="city"
      required
      onChange={handleCityChange}
    >
      <option value="">Choose City</option>
      <option>New Delhi</option>
      <option>Noida</option>
      <option>Gurgaon</option>
      <option>Mumbai</option>
      <option>Pune</option>
      <option>Bangalore</option>
    </select>
  </div>

  <button type="submit" className="cities-btn">
    Connect Now
  </button>

</form>

      </div>

    </div>

  </div>

</section>
      <Footer />

      {showModal && (
        <div className="modal-overlay" onClick={()=>setShowModal(false)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <button onClick={()=>setShowModal(false)}>✕</button>
            <h3>Contact Us</h3>
            <form onSubmit={(e)=>{
              e.preventDefault();
              const name=e.target.name.value;
              window.open(`https://wa.me/8527417771?text=Hi I'm ${name}`,"_blank");
            }}>
              <input name="name" placeholder="Name" required/>
              <input name="email" placeholder="Email" required/>
              <textarea name="message" placeholder="Message"/>
              <button type="submit">Send</button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default Home;